<template>
	<div class="download-button">
		<button class="button button--black no-wrap" @click="$emit('downloadClicked')" :title="title">
			{{ buttonText }}
			<span class="icon icon-download" aria-hidden="true"></span>
		</button>
	</div>
</template>

<script>
export default {
	name: "DownloadButton",
	props: {
		title: {
			type: String,
			default: ""
		},
		buttonText: {
			type: String,
			default: ""
		}
	}
};
</script>

<style lang="scss">
.download-button {
	@include from-lg {
		text-align: right;
	}

	button {
		padding-top: 16px;
		padding-bottom: 16px;

		@include to-lg {
			width: 100%;
			margin-bottom: 35px;
		}
	}
}
</style>
